import { useContext, useEffect } from 'react';
import { ChatbotContext, ChatbotContextPayload } from '../../../../context/chatbotContext';
import StepContainer from './global/stepContainer';
import AccountDetails from './global/calendlyAccountDetails';
import { CalendlyContext, CalendlyContextType } from '../../../../context/calendlyIntegrationContext';
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import { GenericDataContext, GenericDataContextPayload } from '../../../../context/genericDataContext';
import { useSearchParams } from 'react-router-dom';
import { AIChatbotBreadcrumb, chatbotDetailsBreadcrumb, chatbotIntegrationsBreadcrumb, homeBreadcrumb } from '../../../../utils/breadcrumb';

const AppointmentSchedule = () => {
    const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { setGenericChatbotCalendlyData, genericChatbotCalendlyData, genericCalendlyData, setGenericCalendlyData, GetGenericCalendlyData } = useContext(CalendlyContext) as CalendlyContextType;
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;
    let pathname = window.location.pathname.toLowerCase();

    const [searchParams] = useSearchParams();
    const chatbot_id = searchParams.get('chatbot_id');

    useEffect(() => {
        const genericDataCall = async () => {
            if (chatBotDetails && chatBotDetails?.chatbot_calendly_data) {
                setGenericChatbotCalendlyData(chatBotDetails?.chatbot_calendly_data)
            }
            try {
                setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
                const response = await GetGenericCalendlyData();
                if (!(response.status)) {
                    setGenericCalendlyData([]) 
                    handleError(response);
                }
            } catch (error) {
                console.log(error, 'error')
            } finally {
                setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
            }
        }
        genericDataCall() 

        const updatedBreadcrumbs = [
            {...homeBreadcrumb}, 
            AIChatbotBreadcrumb, 
            {...chatbotDetailsBreadcrumb, name: chatBotDetails?.chatbot_name ? chatBotDetails?.chatbot_name : "Chatbot", path: `/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot_id}`},
            {...chatbotIntegrationsBreadcrumb, path: `/chatbot/viewchatbot/integration?chatbot_id=${chatbot_id}`}, 
            {name: "Calendly", path: `${pathname}?chatbot_id=${chatbot_id}`, isActive: true},
        ]; 
        setBreadCrumbs(updatedBreadcrumbs);
    }, [chatBotDetails])

    return (
        <>
            {genericCalendlyData &&
                <>
                    {(genericCalendlyData && genericCalendlyData?.length > 0) || (genericChatbotCalendlyData && genericChatbotCalendlyData?.length > 0) ?
                        <>
                            <AccountDetails generic_calendly_data={genericCalendlyData} chatbot_calendly_data={genericChatbotCalendlyData} flagEdit={true} />
                        </> :
                        <>
                            <StepContainer />
                        </>}
                </>
            }

        </>
    );
};

export default AppointmentSchedule;
